/**
 * gist-atc.js — progressive enhancement for the bespoke add-to-cart forms.
 *
 * The gxf-/gxa-/gxe-/gxl-/gxb- sections post a plain HTML form carrying
 * return_to=/cart, so adding an item throws the visitor onto a different page.
 * Mid-browse that is a hard context switch: the shelf they were scanning is
 * gone and the thread is lost — a common point of abandonment for ADHD users.
 *
 * This adds via the Cart AJAX API and hands the result to the theme's existing
 * <cart-drawer>, so the item appears in place.
 *
 * Two correctness rules learned from the theme's own code:
 *  1. CartDrawer.renderContents() reads data.sections[...] directly, so the
 *     sections it needs MUST be requested in the add call. We ask the drawer
 *     itself via getSectionsToRender() rather than hardcoding ids.
 *  2. The fallback must never re-POST after a successful add, or the item is
 *     added twice. We only fall back when the add itself failed; if the add
 *     succeeded but rendering did not, we navigate instead.
 */
(function () {
  'use strict';

  function drawerSections(drawer) {
    try {
      if (typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map(function (s) { return s.section; });
      }
    } catch (e) { /* fall through */ }
    return null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form || form.hasAttribute('data-gist-atc-skip')) return;
    // The theme's own components already AJAX — leave them alone.
    if (form.closest('product-form, quick-add-drawer')) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // native submit

    var sections = drawerSections(drawer);
    if (!sections || !sections.length) return; // cannot render — let the form navigate

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    var label = btn ? btn.textContent : '';
    var restore = function () { if (btn) { btn.disabled = false; btn.textContent = label; } };
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var body = new FormData(form);
    body.delete('return_to');
    body.append('sections', sections.join(','));

    var added = false;
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        added = true;
        restore();
        drawer.renderContents(data, true);
      })
      .catch(function () {
        restore();
        // Add succeeded but the drawer could not render: do NOT re-submit
        // (that would add a second copy) — just go to the cart page.
        if (added) { window.location.href = '/cart'; return; }
        // Add genuinely failed: let the browser do it natively so the shopper
        // is never left with a button that did nothing.
        form.submit();
      });
  }, false);
})();
